package de.katoonerie.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.ExperimentalComposeWebSvgApi
import org.jetbrains.compose.web.attributes.AttrsScope
import org.jetbrains.compose.web.svg.Path
import org.jetbrains.compose.web.svg.Svg
import org.jetbrains.compose.web.svg.fill
import org.w3c.dom.svg.SVGElement

@OptIn(ExperimentalComposeWebSvgApi::class)
@Composable
fun LinkIcon(attrs: (AttrsScope<SVGElement>.() -> Unit)? = null) {
    Svg(viewBox = "0 0 24 24", attrs = {
        attrs?.invoke(this)
        fill("none")
        attr("stroke", "currentColor")
        attr("stroke-width", "1.5")
    }) {
        Path(
            d = "M13.19 8.688a4.5 4.5 0 011.242 7.244l-4.5 4.5a4.5 4.5 0 01-6.364-6.364l1.757-1.757m13.35-.622l1.757-1.757a4.5 4.5 0 00-6.364-6.364l-4.5 4.5a4.5 4.5 0 001.242 7.244",
            attrs = {
                attr("stroke-linecap", "round")
                attr("stroke-linejoin", "round")
            }
        )
    }
}

@OptIn(ExperimentalComposeWebSvgApi::class)
@Composable
fun VideoCameraIcon(attrs: (AttrsScope<SVGElement>.() -> Unit)? = null) {
    Svg(viewBox = "0 0 24 24", attrs = {
        attrs?.invoke(this)
        fill("none")
        attr("stroke", "currentColor")
        attr("stroke-width", "1.5")
    }) {
        Path(
            d = "M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z",
            attrs = { attr("stroke-linecap", "round") }
        )
    }
}

@OptIn(ExperimentalComposeWebSvgApi::class)
@Composable
fun AtSymbol(attrs: (AttrsScope<SVGElement>.() -> Unit)? = null) {
    Svg(viewBox = "0 0 24 24", attrs = {
        attrs?.invoke(this)
        fill("none")
        attr("stroke", "currentColor")
        attr("stroke-width", "1.5")
    }) {
        Path(
            d = "M16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 10-2.636 6.364M16.5 12V8.25",
            attrs = { attr("stroke-linecap", "round") }
        )
    }
}

@OptIn(ExperimentalComposeWebSvgApi::class)
@Composable
fun Document(attrs: (AttrsScope<SVGElement>.() -> Unit)? = null) {
    Svg(viewBox = "0 0 24 24", attrs = {
        attrs?.invoke(this)
        fill("none")
        attr("stroke", "currentColor")
        attr("stroke-width", "1.5")
    }) {
        Path(
            d = "M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z",
            attrs = {
                attr("stroke-linecap", "round")
                attr("stoke-linejoin", "round")
            }
        )
    }
}

@OptIn(ExperimentalComposeWebSvgApi::class)
@Composable
fun XMark(attrs: (AttrsScope<SVGElement>.() -> Unit)? = null) {
    Svg(viewBox = "0 0 24 24", attrs = {
        attrs?.invoke(this)
        fill("none")
        attr("stroke", "currentColor")
        attr("stroke-width", "1.5")
    }) {
        Path(
            d = "M6 18L18 6M6 6l12 12",
            attrs = {
                attr("stroke-linecap", "round")
                attr("stoke-linejoin", "round")
            }
        )
    }
}

@OptIn(ExperimentalComposeWebSvgApi::class)
@Composable
fun UTurnUp(attrs: (AttrsScope<SVGElement>.() -> Unit)? = null) {
    Svg(viewBox = "0 0 24 24", attrs = {
        attrs?.invoke(this)
        fill("none")
        attr("stroke", "currentColor")
        attr("stroke-width", "1.5")
    }) {
        Path(
            d = "M9 9l6-6m0 0l6 6m-6-6v12a6 6 0 01-12 0v-3",
            attrs = {
                attr("stroke-linecap", "round")
                attr("stoke-linejoin", "round")
            }
        )
    }
}

@OptIn(ExperimentalComposeWebSvgApi::class)
@Composable
fun ArrowPath(attrs: (AttrsScope<SVGElement>.() -> Unit)? = null) {
    Svg(viewBox = "0 0 24 24", attrs = {
        attrs?.invoke(this)
        fill("none")
        attr("stroke", "currentColor")
        attr("stroke-width", "1.5")
    }) {
        Path(
            d = "M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99",
            attrs = {
                attr("stroke-linecap", "round")
                attr("stoke-linejoin", "round")
            }
        )
    }
}

@OptIn(ExperimentalComposeWebSvgApi::class)
@Composable
fun ExclamationCircle(attrs: (AttrsScope<SVGElement>.() -> Unit)? = null) {
    Svg(viewBox = "0 0 24 24", attrs = {
        attrs?.invoke(this)
        fill("none")
        attr("stroke", "currentColor")
        attr("stroke-width", "1.5")
    }) {
        Path(
            d = "M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z",
            attrs = {
                attr("stroke-linecap", "round")
                attr("stoke-linejoin", "round")
            }
        )
    }
}

@OptIn(ExperimentalComposeWebSvgApi::class)
@Composable
fun ExclamationTriangle(attrs: (AttrsScope<SVGElement>.() -> Unit)? = null) {
    Svg(viewBox = "0 0 24 24", attrs = {
        attrs?.invoke(this)
        fill("none")
        attr("stroke", "currentColor")
        attr("stroke-width", "1.5")
    }) {
        Path(
            d = "M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z",
            attrs = {
                attr("stroke-linecap", "round")
                attr("stoke-linejoin", "round")
            }
        )
    }
}

@OptIn(ExperimentalComposeWebSvgApi::class)
@Composable
fun QuestionMarkCircle(attrs: (AttrsScope<SVGElement>.() -> Unit)? = null) {
    Svg(viewBox = "0 0 24 24", attrs = {
        attrs?.invoke(this)
        fill("none")
        attr("stroke", "currentColor")
        attr("stroke-width", "1.5")
    }) {
        Path(
            d = "M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z",
            attrs = {
                attr("stroke-linecap", "round")
                attr("stoke-linejoin", "round")
            }
        )
    }
}
